<template>
  <div>
    <!-- <p>-{{ quotes[random()].text }}-</p> -->
  </div>
</template>

<script>
export default {
  name: "Quotecomponent",
  /* data() {
    return {
      quotes: [
        {
          id: 0,
          text: "Text 1",
        },
        {
          id: 1,
          text: "Testar 2 något",
        },
        {
          id: 2,
          text: "Testar 3",
        },
      ],
    };
  },
  method: {
    random: function() {
      return Math.floor(Math.random() * 2);
    },
  }, */
};
</script>
